/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class CreateLockConfigRuleResponse {
    getFixupPrototypeFunction() { return CreateLockConfigRuleResponse.fixupPrototype; }

    static newInstance(model: Partial<CreateLockConfigRuleResponse>): CreateLockConfigRuleResponse {
        let obj = Object.assign(new CreateLockConfigRuleResponse(), model);
        CreateLockConfigRuleResponse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<CreateLockConfigRuleResponse>): CreateLockConfigRuleResponse {
        if (!model) return null;
        return CreateLockConfigRuleResponse.newInstance(<CreateLockConfigRuleResponse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: CreateLockConfigRuleResponse) {
        if (!obj) return;

        models.CreateLockConfigRuleResponse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: CreateLockConfigRuleResponse): boolean {
        Object.setPrototypeOf(obj, CreateLockConfigRuleResponse.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Config rule id
     */
    config_rule_id: string;

}
